import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchMe, login as apiLogin, register as apiRegister } from "./api";

const AuthContext = createContext({ user: null, loading: true, login: () => {}, logout: () => {}, register: () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = window.localStorage.getItem("sat_token");
    if (!token) { setLoading(false); return; }
    fetchMe()
      .then((u) => setUser(u))
      .catch(() => { window.localStorage.removeItem("sat_token"); })
      .finally(() => setLoading(false));
  }, []);

  const doLogin = async (email, password) => {
    const r = await apiLogin({ email, password });
    window.localStorage.setItem("sat_token", r.token);
    setUser(r.user);
    return r.user;
  };

  const doRegister = async (email, password, name) => {
    const r = await apiRegister({ email, password, name });
    window.localStorage.setItem("sat_token", r.token);
    setUser(r.user);
    return r.user;
  };

  const logout = () => {
    window.localStorage.removeItem("sat_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login: doLogin, logout, register: doRegister }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
